import { useEffect, useRef } from 'react';
import { useReactToPrint } from 'react-to-print';

type PrintContainerProperties = {
  children: React.ReactNode;
  onAfterPrint: () => void;
};

export function PrintContainer({ children, onAfterPrint }: PrintContainerProperties) {
  const printReference = useRef(null);
  const handlePrint = useReactToPrint({
    contentRef: printReference,
    onAfterPrint,
  });

  // Fire once per mount. `handlePrint`'s identity changes whenever the parent
  // re-renders (the `onAfterPrint` prop is typically a fresh arrow), and a
  // second invocation tears down the in-flight print iframe — react-to-print
  // then logs "contentWindow of the print iframe did not load" 500ms later.
  const startedRef = useRef(false);
  useEffect(() => {
    if (startedRef.current) {
      return;
    }

    startedRef.current = true;
    handlePrint();
  }, [handlePrint]);

  return (
    <div ref={printReference} className="w-full h-full hidden print:block">
      {children}
    </div>
  );
}
